var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { PaymentActionTypes, SetBrandSubscriptionState } from '@caroo/payment/actions/payment.actions';
import { PaymentService } from '@caroo/payment/payment.service';
import { Actions, Effect, ofType } from '@ngrx/effects';
import { map, switchMap, throttleTime } from 'rxjs/operators';
export class PaymentEffects {
    constructor(actions$, paymentService) {
        this.actions$ = actions$;
        this.paymentService = paymentService;
        this.loadBrandSubscriptionState$ = this.actions$
            .pipe(ofType(PaymentActionTypes.LoadBrandSubscriptionState))
            .pipe(throttleTime(1000))
            .pipe(switchMap(() => this.paymentService.getBrandSubscriptionState()))
            .pipe(map(subscriptionState => new SetBrandSubscriptionState({ subscriptionState })));
    }
}
__decorate([
    Effect(),
    __metadata("design:type", Object)
], PaymentEffects.prototype, "loadBrandSubscriptionState$", void 0);
